module.exports = "data:image/gif;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJzdGF0aWMvaW1nL3dlaWJvLjA1NjliZjUuZ2lmIjsNCg0KDQovLy8vLy8vLy8vLy8vLy8vLy8NCi8vIFdFQlBBQ0sgRk9PVEVSDQovLyAuL3NyYy9hc3NldHMvaW1hZ2VzL3dlaWJvLmdpZg0KLy8gbW9kdWxlIGlkID0gNXNNKw0KLy8gbW9kdWxlIGNodW5rcyA9IDI1"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weibo.gif
// module id = 5sM+
// module chunks = 49